import {SET_PRESTASHOP_PRODUCTS} from "./constants";
import {svcPsService} from "../../../_services/ps-service";
import {globalCatch} from "../../../_services/global-catch";

export const setPrestashopProducts= payload => ({type: SET_PRESTASHOP_PRODUCTS, payload});

export const fetchPrestashopProducts = (shopCode) =>
    globalCatch.catch(async (dispatch) => {
        const prestashopProducts = await (await svcPsService()).GetProductsSameCategoryFromShopCode(shopCode);
        dispatch(setPrestashopProducts(prestashopProducts));
        return prestashopProducts;
    })

